"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.FlagrContext = exports.Consumer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var flagr = _interopRequireWildcard(require("./flagr"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const FlagrContext = /*#__PURE__*/(0, _react.createContext)({
  flags: {},
  fetchFlag: () => null
});
exports.FlagrContext = FlagrContext;

class FlagrProvider extends _react.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      flags: this.props.flags,
      requests: new Set(Object.keys(this.props.flags))
    });

    _defineProperty(this, "getContext", () => ({
      flags: this.state.flags,
      fetchFlag: this.fetchFlag
    }));

    _defineProperty(this, "fetchFlag", async flagKey => {
      // Don't refetch if we've already made a request
      if (this.state.requests.has(flagKey)) return; // Keep track of the request

      this.state.requests.add(flagKey);
      const flag = await flagr.fetchFlag(flagKey, {
        id: this.props.entityId,
        type: this.props.entityType,
        context: this.props.entityContext
      }, this.props);
      this.setState(state => ({
        flags: { ...state.flags,
          [flagKey]: flag
        }
      }));
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.flags !== this.props.flags) {
      // If the flags passed in change, spread in the new flags and update tracking of the requests
      const newRequests = new Set();
      this.state.requests.forEach(request => newRequests.add(request));
      Object.keys(this.props.flags).forEach(request => newRequests.add(request));
      this.setState({
        flags: { ...this.state.flags,
          ...this.props.flags
        },
        requests: newRequests
      });
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(FlagrContext.Provider, {
      value: this.getContext()
    }, this.props.children);
  }

}

_defineProperty(FlagrProvider, "propTypes", {
  flags: _propTypes.default.object.isRequired,
  entityId: _propTypes.default.string.isRequired,
  entityType: _propTypes.default.string,
  entityContext: _propTypes.default.object,
  url: _propTypes.default.string.isRequired,
  fetch: _propTypes.default.func
});

_defineProperty(FlagrProvider, "defaultProps", {
  flags: {}
});

const Provider = FlagrProvider;
exports.Provider = Provider;
const Consumer = FlagrContext.Consumer;
exports.Consumer = Consumer;